var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    hardline = _require$doc$builders.hardline,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line;

var StructDefinition = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat(['struct ', node.name, ' {', indent(line), indent(join(hardline, path.map(_print, 'members').map(function (element) {
      return concat([element, ';']);
    }))), hardline, '}']);
  }
};
module.exports = StructDefinition;